var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBallPen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7718_40947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8868 8.85602L13.3565 8.32577L5.9315 15.7508H2.75V12.5685L11.2347 4.08302L15.4775 8.32577C15.6181 8.46642 15.6971 8.65715 15.6971 8.85602C15.6971 9.05489 15.6181 9.24563 15.4775 9.38627L10.175 14.6895L9.11375 13.629L13.8868 8.85602ZM12.296 7.26527L11.2347 6.20477L4.25 13.1895V14.2508H5.3105L12.296 7.26527ZM14.417 1.96202L16.5387 4.08302C16.6794 4.22367 16.7583 4.4144 16.7583 4.61327C16.7583 4.81214 16.6794 5.00288 16.5387 5.14352L15.4775 6.20477L12.296 3.02252L13.3565 1.96202C13.4971 1.82142 13.6879 1.74243 13.8868 1.74243C14.0856 1.74243 14.2764 1.82142 14.417 1.96202Z",
    fill: "#0A2756"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7718_40947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallPen);
export default __webpack_public_path__ + "static/media/ball-pen.b9a8eca280be85c534cf20cdba290860.svg";
export { ForwardRef as ReactComponent };